import React from "react";
import ContactUss from "../Assets/contact.jpg";
import Location from "../Assets/Location.jpg";
import {
  FaGlobe,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaCogs,
  FaBolt,
  FaLeaf,
  FaDraftingCompass,
  FaSyncAlt,
  FaTools,
  FaArrowRight,
} from "react-icons/fa";

function ContactUs() {
const contactCards = [
  {
    title: "Website",
    value: "www.electromates.co.in",
    link: "https://www.electromates.co.in",
    icon: <FaGlobe size={24} />,
  },
  {
    title: "Email",
    value: "office@electromates.co.in",
    link: "mailto:office@electromates.co.in",
    icon: <FaEnvelope size={24} />,
  },
  {
    title: "Phone",
    value: "+91 982 317 6730",
    link: "tel:+919823176730",
    icon: <FaPhoneAlt size={22} />,
  },
];

const supportAreas = [
  {
    text: "Industrial Automation Solutions",
    icon: <FaCogs size={22} />,
  },
  {
    text: "Energy Efficiency Projects",
    icon: <FaBolt size={22} />,
  },
  {
    text: "Sustainability & Environmental Solutions",
    icon: <FaLeaf size={22} />,
  },
  {
    text: "Engineering & Design Services",
    icon: <FaDraftingCompass size={22} />,
  },
  {
    text: "Retrofit & Modernization Support",
    icon: <FaSyncAlt size={22} />,
  },
  {
    text: "Installation & Commissioning Assistance",
    icon: <FaTools size={22} />,
  },
];

return (
  <div style={{ backgroundColor: "#f7fbff", overflowX: "hidden" }}>
  <section
  style={{
    background:
      "linear-gradient(135deg, #edf7ff 0%, #d8ecfb 45%, #f7fbff 100%)",
    padding: "90px 0 70px 0",
    position: "relative",
    overflow: "hidden",
  }}
>
  <div
    style={{
      position: "absolute",
      top: "30px",
      left: "-70px",
      width: "220px",
      height: "220px",
      borderRadius: "50%",
      background: "rgba(29,169,232,0.10)",
      filter: "blur(10px)",
      animation: "floatY 5s ease-in-out infinite",
      zIndex: 0,
      pointerEvents: "none",
    }}
  ></div>

  <div
    style={{
      position: "absolute",
      bottom: "20px",
      right: "-60px",
      width: "240px",
      height: "240px",
      borderRadius: "50%",
      background: "rgba(11,92,173,0.10)",
      filter: "blur(10px)",
      animation: "floatY 6s ease-in-out infinite",
      zIndex: 0,
      pointerEvents: "none",
    }}
  ></div>

  <div
    className="container"
    style={{
      position: "relative",
      zIndex: 2,
    }}
  >
    <div className="row align-items-center gy-5">
      <div className="col-lg-6">
        <div
          style={{
            display: "inline-block",
            backgroundColor: "#e6f4ff",
            color: "#0B5CAD",
            padding: "10px 18px",
            borderRadius: "30px",
            fontWeight: 700,
            fontSize: "14px",
            marginBottom: "18px",
            animation: "fadeUp 1s ease",
          }}
        >
          CONTACT US
        </div>

        <h1
          style={{
            color: "#0B5CAD",
            fontWeight: 800,
            fontSize: "clamp(2.2rem, 5vw, 3.8rem)",
            lineHeight: "1.15",
            marginBottom: "18px",
            animation: "fadeUp 1.1s ease",
          }}
        >
          Let’s Connect
          <br />
          With Electromates
        </h1>

        <p
          style={{
            color: "#4a5568",
            fontSize: "17px",
            lineHeight: "1.9",
            marginBottom: "24px",
            animation: "fadeUp 1.2s ease",
          }}
        >
          Reach out to Electromates for automation, energy-efficiency,
          sustainability and engineering solution discussions. We would be
          glad to connect with you for your next project or requirement.
        </p>

        <div className="row g-3">
          <div className="col-4">
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "18px",
                padding: "16px 10px",
                boxShadow: "0 12px 28px rgba(11,92,173,0.08)",
                textAlign: "center",
                height: "100%",
              }}
            >
              <h3
                style={{
                  color: "#1DA9E8",
                  fontWeight: 800,
                  marginBottom: "6px",
                  fontSize: "clamp(1rem, 2vw, 1.6rem)",
                }}
              >
                Fast
              </h3>
              <p
                style={{
                  margin: 0,
                  color: "#2d3748",
                  fontWeight: 600,
                  fontSize: "clamp(11px, 1.5vw, 14px)",
                  lineHeight: "1.4",
                }}
              >
                Business Contact
              </p>
            </div>
          </div>

          <div className="col-4">
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "18px",
                padding: "16px 10px",
                boxShadow: "0 12px 28px rgba(11,92,173,0.08)",
                textAlign: "center",
                height: "100%",
              }}
            >
              <h3
                style={{
                  color: "#1DA9E8",
                  fontWeight: 800,
                  marginBottom: "6px",
                  fontSize: "clamp(1rem, 2vw, 1.6rem)",
                }}
              >
                Direct
              </h3>
              <p
                style={{
                  margin: 0,
                  color: "#2d3748",
                  fontWeight: 600,
                  fontSize: "clamp(11px, 1.5vw, 14px)",
                  lineHeight: "1.4",
                }}
              >
                Email & Phone
              </p>
            </div>
          </div>

          <div className="col-4">
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "18px",
                padding: "16px 10px",
                boxShadow: "0 12px 28px rgba(11,92,173,0.08)",
                textAlign: "center",
                height: "100%",
              }}
            >
              <h3
                style={{
                  color: "#1DA9E8",
                  fontWeight: 800,
                  marginBottom: "6px",
                  fontSize: "clamp(1rem, 2vw, 1.6rem)",
                }}
              >
                Project
              </h3>
              <p
                style={{
                  margin: 0,
                  color: "#2d3748",
                  fontWeight: 600,
                  fontSize: "clamp(11px, 1.5vw, 14px)",
                  lineHeight: "1.4",
                }}
              >
                Solution Support
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-6">
        <div
          style={{
            width: "100%",
            position: "relative",
            zIndex: 1,
            borderRadius: "28px",
            overflow: "hidden",
            animation: "zoomInSoft 1.2s ease",
            aspectRatio: "16 / 10",
          }}
        >
          <img
            src={ContactUss}
            alt="Contact Us"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>
      </div>
    </div>
  </div>
</section>

    <section className="py-5">
      <div className="container py-4">
        <div className="text-center mb-5">
          <h2
            style={{
              color: "#0B5CAD",
              fontWeight: 800,
              marginBottom: "12px",
            }}
          >
            Contact Information
          </h2>
          <p
            style={{
              maxWidth: "760px",
              margin: "0 auto",
              color: "#5b6777",
              lineHeight: "1.8",
            }}
          >
            You can connect with Electromates using the contact details shared
            in the company brochure.
          </p>
        </div>

        <div className="row g-4 justify-content-center">
          {contactCards.map((item, index) => (
            <div className="col-md-6 col-lg-4" key={index}>
              <a
                href={item.link}
                target={item.title === "Website" ? "_blank" : "_self"}
                rel="noreferrer"
                style={{ textDecoration: "none" }}
              >
                <div
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "24px",
                    padding: "30px",
                    height: "100%",
                    boxShadow: "0 14px 34px rgba(11,92,173,0.08)",
                    border: "1px solid rgba(11,92,173,0.06)",
                    textAlign: "center",
                    transition: "0.3s",
                  }}
                >
                  <div
                    style={{
                      width: "64px",
                      height: "64px",
                      borderRadius: "18px",
                      backgroundColor: "#e6f4ff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#0B5CAD",
                      margin: "0 auto 18px",
                    }}
                  >
                    {item.icon}
                  </div>

                  <h3
                    style={{
                      color: "#0B5CAD",
                      fontWeight: 700,
                      marginBottom: "12px",
                      fontSize: "24px",
                    }}
                  >
                    {item.title}
                  </h3>

                  <p
                    style={{
                      color: "#4a5568",
                      lineHeight: "1.8",
                      marginBottom: 0,
                      fontWeight: 600,
                      wordBreak: "break-word",
                    }}
                  >
                    {item.value}
                  </p>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section
      className="py-5"
      style={{
        background: "linear-gradient(180deg, #ffffff 0%, #eef7fd 100%)",
      }}
    >
      <div className="container py-4">
        <div className="row align-items-center gy-4">
          <div className="col-lg-6">
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "24px",
                padding: "34px",
                boxShadow: "0 12px 35px rgba(0,0,0,0.05)",
                borderLeft: "6px solid #1DA9E8",
                height: "100%",
              }}
            >
              <h2
                style={{
                  color: "#0B5CAD",
                  fontWeight: 800,
                  marginBottom: "18px",
                }}
              >
                Company Details
              </h2>

              <p style={{ color: "#4a5568", lineHeight: "1.95" }}>
                <strong style={{ color: "#0B5CAD" }}>
                  Electromates Robotics & Automation (India) Pvt. Ltd.
                </strong>
              </p>

              <p
                style={{
                  color: "#4a5568",
                  lineHeight: "1.95",
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px",
                }}
              >
                <span style={{ color: "#0B5CAD", marginTop: "4px" }}>
                  <FaGlobe />
                </span>
                <span>
                  Website:{" "}
                  <a
                    href="https://www.electromates.co.in"
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "#0B5CAD", fontWeight: 600 }}
                  >
                    www.electromates.co.in
                  </a>
                </span>
              </p>

              <p
                style={{
                  color: "#4a5568",
                  lineHeight: "1.95",
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px",
                }}
              >
                <span style={{ color: "#0B5CAD", marginTop: "4px" }}>
                  <FaEnvelope />
                </span>
                <span>
                  Email:{" "}
                  <a
                    href="mailto:office@electromates.co.in"
                    style={{ color: "#0B5CAD", fontWeight: 600 }}
                  >
                    office@electromates.co.in
                  </a>
                </span>
              </p>

              <p
                style={{
                  color: "#4a5568",
                  lineHeight: "1.95",
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px",
                }}
              >
                <span style={{ color: "#0B5CAD", marginTop: "4px" }}>
                  <FaPhoneAlt />
                </span>
                <span>
                  Phone:{" "}
                  <a
                    href="tel:+919823176730"
                    style={{ color: "#0B5CAD", fontWeight: 600 }}
                  >
                    +91 982 317 6730
                  </a>
                </span>
              </p>

              <p
                style={{
                  color: "#4a5568",
                  lineHeight: "1.95",
                  marginBottom: 0,
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px",
                }}
              >
                <span style={{ color: "#0B5CAD", marginTop: "4px" }}>
                  <FaMapMarkerAlt />
                </span>
                <span>
                  Address: Plot No. 14, Gut No 67, Wadegaon Kolhathi, Waluj,
                  MIDC, Chh.Sambhajinagar, (Aurangabad), Maharashtra-431136
                </span>
              </p>
            </div>
          </div>

         <div className="col-lg-6">
  <div
    style={{
      width: "100%",
      borderRadius: "24px",
      overflow: "hidden",
      position: "relative",
      aspectRatio: "16 / 10",
    }}
  >
    <img
      src={Location}
      alt="Office Location"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        display: "block",
      }}
    />
  </div>
</div>
        </div>
      </div>
    </section>

    <section className="py-5">
      <div className="container py-4">
        <h2
          style={{
            color: "#0B5CAD",
            fontWeight: 800,
            marginBottom: "24px",
            textAlign: "center",
          }}
        >
          We Can Support You With
        </h2>

        <div className="row g-3">
          {supportAreas.map((item, index) => (
            <div className="col-sm-6 col-lg-4" key={index}>
              <div
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "18px",
                  padding: "20px",
                  boxShadow: "0 8px 20px rgba(11,92,173,0.06)",
                  color: "#2d3748",
                  fontWeight: 600,
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  gap: "14px",
                }}
              >
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    minWidth: "48px",
                    borderRadius: "14px",
                    backgroundColor: "#e6f4ff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#0B5CAD",
                  }}
                >
                  {item.icon}
                </div>

                <div style={{ lineHeight: "1.6" }}>{item.text}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="py-5">
      <div className="container py-4">
        <div
          style={{
            background: "linear-gradient(135deg, #0B5CAD 0%, #1DA9E8 100%)",
            borderRadius: "28px",
            padding: "50px 30px",
            textAlign: "center",
            color: "#ffffff",
            boxShadow: "0 16px 40px rgba(11,92,173,0.20)",
          }}
        >
          <h2 style={{ fontWeight: 800, marginBottom: "14px" }}>
            Ready to Discuss Your Requirement?
          </h2>
          <p
            style={{
              maxWidth: "760px",
              margin: "0 auto 24px",
              lineHeight: "1.85",
              color: "rgba(255,255,255,0.92)",
            }}
          >
            Connect with Electromates for automation, energy and
            sustainability-focused engineering support.
          </p>

          <div className="d-flex flex-wrap justify-content-center gap-3">
            <a
              href="mailto:office@electromates.co.in"
              className="btn"
              style={{
                backgroundColor: "#ffffff",
                color: "#0B5CAD",
                padding: "12px 28px",
                borderRadius: "30px",
                fontWeight: 700,
                border: "none",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <FaEnvelope />
              Email Us
            </a>

            <a
              href="tel:+919823176730"
              className="btn"
              style={{
                backgroundColor: "transparent",
                color: "#ffffff",
                padding: "12px 28px",
                borderRadius: "30px",
                fontWeight: 700,
                border: "2px solid #ffffff",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <FaPhoneAlt />
              Call Now
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
);
}

export default ContactUs;